import { gql, useMutation } from '@apollo/client';
import {
  UpsertClientAndCreateGiftCardTransactionInput,
  MercadoPagoCreateGiftCardPurchaseResponse,
} from 'apollo/types';

const UPSERT_MERCADOPAGO_GIFT_CARD_PURCHASE = gql`
  mutation upsertMercadoPagoGiftCardTransaction(
    $clientArguments: UpsertClientArgs!
    $giftCardPurchaseArguments: GiftCardPurchaseInput!
    $billingSystemArguments: BillingSystemInputArgs!
  ) {
    createGiftCardPurchase(
      input: {
        clientArguments: $clientArguments
        giftCardPurchaseArguments: $giftCardPurchaseArguments
        billingSystemArguments: $billingSystemArguments
      }
    ) {
      url
      token
    }
  }
`;
const upsertMercadoPagoGiftCardTransactionMutation = () => {
  return useMutation<
    MercadoPagoCreateGiftCardPurchaseResponse,
    UpsertClientAndCreateGiftCardTransactionInput
  >(UPSERT_MERCADOPAGO_GIFT_CARD_PURCHASE);
};

export default upsertMercadoPagoGiftCardTransactionMutation;
